<content>
  <form [formGroup]="confirmRegistrationForm" [ngClass]="{'show-error': showError}">
    <div class="infoPassword">{{'usuarios.confirmarRegistro.passRegistrationRequirements' | translate}}</div>
    <div class="entry">
      <label>{{'usuarios.confirmarRegistro.nombre' | translate}} *</label>
      <input formControlName="nombre">
    </div>
    <div class="entry">
      <label>{{'usuarios.confirmarRegistro.apellido' | translate}} *</label>
      <input formControlName="apellido">
    </div>
    <div class="entry">
      <label>{{'usuarios.confirmarRegistro.telefono' | translate}}</label>
      <input formControlName="telefono">
    </div>
    <div class="entry">
      <label>{{'usuarios.confirmarRegistro.cargo' | translate}} *</label>
      <input formControlName="cargo">
    </div>
    <div class="entry">
      <label>{{'usuarios.confirmarRegistro.password' | translate}} *</label>
      <input [type]="showNPassword ? 'text' : 'password'" formControlName="password">
      <span>
        <i [ngClass]="showNPassword ? 'fa fa-eye-slash': 'fa fa-eye'" (click)="showNPassword = !showNPassword"
            title="{{ showNPassword ? ('session.hidePassword' | translate) : ('session.showPassword' | translate)}}"></i>
      </span>
    </div>
    <div class="entry">
      <label>{{'usuarios.confirmarRegistro.repitePassword' | translate}} *</label>
      <input [type]="showRNPassword ? 'text' : 'password'" formControlName="repeatPassword">
      <span>
        <i [ngClass]="showRNPassword ? 'fa fa-eye-slash': 'fa fa-eye'" (click)="showRNPassword = !showRNPassword"
            title="{{ showRNPassword ? ('session.hidePassword' | translate) : ('session.showPassword' | translate)}}"></i>
      </span>
    </div>
    <div class="infoPassword">
      <input type="checkbox" id="terminos" formControlName="terminos">
      <label for="terminos">
        <span style="font-family: regular;">{{'usuarios.confirmarRegistro.crearCuenta' | translate}}&nbsp;
          <a style="display: contents;" href="https://www.gesvatec.com/AvisoLegal.aspx" target="_blank">
            {{'usuarios.confirmarRegistro.terminosYCondiciones' | translate}} </a>
          &nbsp;{{'usuarios.confirmarRegistro.leido' | translate}}&nbsp;
          <a style="display: contents;" href="https://www.gesvatec.com/PoliticaPrivacidad.aspx" target="_blank">
            {{'usuarios.confirmarRegistro.politicaPrivacidad' | translate}}</a></span></label>
    </div>
  </form>
</content>
<footer class="button-bar-center">
  <button [ngClass]="{'disabled': !this.confirmRegistrationForm.get('terminos').value}"
    [disabled]="!this.confirmRegistrationForm.get('terminos').value" (click)="confirmRegistration()">{{
    'global.confirmar' | translate}}</button>
</footer>
<app-toast *ngIf="mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
